export const emptyCardPresets = {
    collapsible: { sx: {} },
    groupWrapper: { sx: {} },
    HeaderAction: () => null,
};
//# sourceMappingURL=card.js.map